import { ErrorMessage } from '@hookform/error-message';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import CustomDialog from 'components/custom-dialog/custom-dialog.component';
import CustomInput from 'components/custom-input/custom-input.component';
import FormError from 'components/form-error/form-error.component';
import TrimTextField from 'components/form/form-fields/trim-text-field/trim-text-field.component';
import MandatoryFieldsInstruction from 'components/form/mandatory-fields-instruction/mandatory-fields-instruction.component';
import IncButton from 'components/inc-button/inc-button.component';
import MessagesDialog from 'components/messages-dialog/messages-dialog.component';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getActivityBasedContent } from 'redux/user/user.actions';

const PromoCode = ({
  open,
  handleClose,
  messages,
  validateResponse,
  checkoutPromoCode,
}) => {
  const { t } = useTranslation();
  const [offerOpen, setOfferOpen] = useState(false);
  const dispatch = useDispatch();
  const methods = useForm();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = methods;

  const handleApplyPromo = async data => {
    const result = await dispatch(
      getActivityBasedContent(null, null, data.promoCode),
    );
    const errorMessage = validateResponse(result);
    if (errorMessage) {
      setError(
        'promoCode',
        {
          type: 'manual',
          message: errorMessage,
        },
        { shouldFocus: true },
      );
      return;
    }

    setOfferOpen(true);
  };

  const name = 'promoCode';

  return (
    <>
      <CustomDialog
        title="Enter Promo Code"
        testId="PromoCode.CustomDialog"
        open={open}
        close={handleClose}
      >
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(handleApplyPromo)}>
            <MandatoryFieldsInstruction />
            <CustomInput>
              <InputLabel htmlFor="promoCode">
                {t('payment.promoCode.label')}*
              </InputLabel>
              <TrimTextField
                id="promoCode"
                inputProps={{
                  'aria-required': true,
                }}
                {...register(name, { required: t('errors.requiredField') })}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <LocalOfferIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => <FormError errorMessage={message} />}
              />
            </CustomInput>
            <Box mt={3}>
              <IncButton
                data-testid="PromoCode.CustomButton"
                type="submit"
                fullWidth
              >
                {t('payment.promoCode.submitAction')}
              </IncButton>
            </Box>
          </form>
        </FormProvider>
      </CustomDialog>
      <MessagesDialog
        open={offerOpen}
        setOpen={setOfferOpen}
        messages={messages}
        testId="PromoCode.MessagesDialog"
        checkoutPromoCode={checkoutPromoCode}
      />
    </>
  );
};

export default PromoCode;
